<template>
  <div>
    <b-dropdown text="Atsisiųsti" class="ml-3" variant="primary" split @click="downloadFile"
      v-if="documentMeta.appendices != null && documentMeta.appendices.length > 0"
    >
      <b-dropdown-item @click="showDownloadAllModal">
        <font-awesome-icon icon="download" class="mr-2" />Atsisiųsti visus
      </b-dropdown-item>
    </b-dropdown>
    <b-button variant="primary" class="ml-3" @click="downloadFile" v-else>Atsisiųsti</b-button>
    
    <b-modal v-model="showModal" title="Atsisiųsti visus" size="lg" @hide="clearAllDocuments" hide-footer>
      <template v-slot:modal-header>
        <div class="d-flex flex-column w-100">
          <div class="d-flex justify-content-between align-items-center pb-2" style="border-bottom: 1px solid #dee2e6;">
            <h5 class="modal-title">Atsisiųsti visus</h5>
            <b-button-close class="ml-3" @click="showModal = false"></b-button-close>
          </div>
          <div class="d-flex justify-content-center align-items-center mt-3 w-100">
            <b-button variant="primary" @click="handleDownloadAll">Atsisiųsti pažymėtus</b-button>
          </div>
        </div>
      </template>
      <div v-if="loading" class="loading-indicator">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <div v-if="documentsList != null && documentsList.length > 0">
          <b-form-checkbox
            v-for="(doc) in documentsList"
            :key="doc.guid"
            v-model="selectedDocuments"
            :value="doc.guid"
            class="large-checkbox"
          >
            {{ doc.title }}
          </b-form-checkbox>
        </div>
        <div v-else>
          Nėra dokumentų, kuriuos būtų galima atsisiųsti.
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { FileRepo } from "../../_Services/repository";
import generateFileName from '../../_Helpers/generate-file-name.js';
import attachementExtractionFromTitle from "@/_Helpers/attachement-extraction-from-title";
import { GetDocumentMeta } from "../../Assets/repository";
export default {
  name: "btn-doc-download",
  props: {
    documentMeta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false, // Modal lango būsena
      documentsList: [], // Dokumentų sąrašas, kuris bus rodomas modale
      selectedDocuments: [], // Pasirinkti dokumentai (jų GUID)
      localRelatedDocuments: [], // Create a local copy of relatedDocuments
      loading: false,
    };
  },
  methods: {
    downloadFile() {
      //console.log(this.documentMeta.guid);
      FileRepo.get(this.documentMeta.guid)
        .then((res) => {
          this.forceFileDownload(res, this.documentMeta);
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    async showDownloadAllModal() {
      this.loading = true;
      if (this.documentMeta.appendices) {
        this.showModal = true;
        const promises = this.documentMeta.appendices.map((appendix) => {
          return GetDocumentMeta(appendix.id, this.documentMeta.version)
            .then((res) => {
              this.localRelatedDocuments.push(res.data);
            })
            .catch(() => {});
        });

        await Promise.all(promises);
        this.loading = false;
        
        this.localRelatedDocuments.sort((a, b) => {
          const extractNumber = (title) => {
            const lastMatch = attachementExtractionFromTitle(title);
            if (title.endsWith(lastMatch)) {
              const match = lastMatch.match(/\d+/); 
              if(match) { 
                return parseInt(match); 
              } 
              return 0;
            } 
            return -1; 
          };

          const numberA = extractNumber(a.title);
          const numberB = extractNumber(b.title);

          return numberA - numberB; // Rūšiuoti pagal skaičių didėjimo tvarka
        });

        this.documentsList = this.localRelatedDocuments;
        this.documentsList.unshift(this.documentMeta);
        this.selectedDocuments = this.documentsList.map(doc => doc.guid);
      }
    },
    closeModal() {
      this.showModal = false;
    },
    clearAllDocuments() {
      this.selectedDocuments = [];
      this.documentsList = [];
      this.localRelatedDocuments = [];
    },
    async handleDownloadAll() {      
      try {
        const downloadPromises = this.selectedDocuments.map(guid => 
          FileRepo.get(guid).then(response => ({ response, guid }))
        );

        this.loading = true;
        const results = await Promise.all(downloadPromises);
        this.loading = false;
        this.showModal = false;

        results.forEach(({ response, guid }) => {
          const documentMeta = this.documentsList.find(doc => doc.guid === guid);
          this.forceFileDownload(response, documentMeta);
        });

      } catch (ex) {
        console.error(ex);
      }
    },
    forceFileDownload(response, documentMeta) {
      let contentDisposition = response.headers["content-disposition"];
      let filename = "file.unkw";
      if (contentDisposition == null) {
        var mime = require("mime-types");
        let contentType = response.headers["content-type"];
        let extention = mime.extension(contentType);
        filename = extention ? `file.${extention}` : "file.adoc";
      } else {
        filename = generateFileName(documentMeta);
      }
      let blob = new Blob([response.data]);
      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      }
    },  
  },
};
</script>

<style>
  .dropdown-toggle {
    background-color: rgb(248, 248, 250)!important;
    border-color: rgb(0, 92, 191)!important;
    color:black!important;
  }
  .dropdown ul { 
    transform: translate3d(-40px, 40px, 0px)!important;
    background-color: rgb(248, 248, 250)!important;
    border-color: rgb(0, 92, 191)!important;
  }
  .dropdown-menu {
    padding: 0!important;
  }
  .dropdown-item {
    border-radius: 0.25rem!important;
    padding: 6px 12px!important;
  }
  .large-checkbox .custom-control-label::before,
  .large-checkbox .custom-control-label::after {
    width: 1.5rem;
    height: 1.5rem;
  }
  .large-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff;
    border-color: #007bff;
  }
  .large-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='white' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e")!important;
  }
  .large-checkbox .custom-control-label {
    padding-left: 1rem;
   padding-top: 3px;
  }
  .loading-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .modal-header {
    border-bottom: 0px solid #fff!important;
  }
  .modal-body {
    padding-top: 0!important;
  }
</style>

<style scoped></style>